module.exports = __webpack_public_path__ + "img/nav-advice.f1e3329.webp";